import ModalActionsProductList from './ModalActionsProductList'
export default ModalActionsProductList